export default "__VITE_ASSET__D5CEtCri__"